import React, { Fragment } from 'react';
import IataUploadComponent from 'src/components/baggage-receipt/iata-upload.component';
// child components
// import HighlightInfoCollectionComponent from '../../components/highlight-info-collection/highlight-info-collection.component';
// import NewHighlightInfoCollectionComponent from '../../components/new-highlight-info-collection/new-highlight-info-collection.component';
// import NewBookingItemsComponent from '../../components/new-booking-items/new-booking-items.component';
import NewBookingItemsAddressComponent from '../../components/new-booking-items-address/new-booking-items-address.component';
import BaggageUploadComponent from '../../components/ccd-baggage-img-upload/baggage-upload.component';
// styles
const styles = require('./pre-slot-collection.scss');
// images
// animations

declare var exponea: any;
interface IProps {
  trackingData: any;
  language: string;
  multiLang: any;
  userBookingRef: string;
  getData: Function;
  queryParams: any;
  userEmail: string;
}

interface IState {
  loaded: boolean;
}

class PreSlotChecklistComponent extends React.Component<IProps, IState> {
  public bookingProductService = null;
  constructor(props: any) {
    super(props);
    this.state = {
      loaded: false,
    };
  }

  componentDidMount() {
    this.setState({ loaded: true });
    exponea.track('tracking_screen', {
      page_name: 'IataUpload',
      product_type: 'ccd',
    });
  }

  public render() {
    const { loaded } = this.state;

    const { trackingData, language, multiLang, userEmail } = this.props;
    console.log(trackingData);

    return (
      <Fragment>
        {loaded ? (
          <div className={styles.mainContent}>
            <div className={styles.sectionWrapperContent}>
              <div className={styles.section}>

                <BaggageUploadComponent
                  language={language}
                  multiLang={multiLang}
                  getData={() => this.props.getData()}
                  bookingJourneyReference={
                    trackingData.bookingJourneyReference
                  }
                  userBookingRef={this.props.userBookingRef}
                  trackingData={trackingData}
                  queryParams={this.props.queryParams}
                  userEmail={userEmail}

                ></BaggageUploadComponent>

                <div className={styles.divider}>

                </div>

                <IataUploadComponent
                  language={language}
                  multiLang={multiLang}
                  getData={() => this.props.getData()}
                  bookingJourneyReference={trackingData.bookingJourneyReference}
                  userBookingRef={this.props.userBookingRef}
                  trackingData={trackingData}
                  queryParams={this.props.queryParams}
                ></IataUploadComponent>

                <NewBookingItemsAddressComponent
                  language={language}
                  multiLang={multiLang}
                  data={trackingData}
                ></NewBookingItemsAddressComponent>
                {/* <NewBookingItemsComponent language={language} multiLang={multiLang} data={trackingData}></NewBookingItemsComponent> */}
                {/* <NewHighlightInfoCollectionComponent language={language} multiLang={multiLang} headerCenter={false}></NewHighlightInfoCollectionComponent> */}
              </div>
            </div>
          </div>
        ) : null}
      </Fragment>
    );
  }
}

export default PreSlotChecklistComponent;



// WEBPACK FOOTER //
// ./src/containers/pre-slot-checklist/pre-slot-checklist.tsx